module.exports = __webpack_public_path__ + "img/import-files.6e370aad.svg";